/** Shared building blocks for Business Builder result panels. */
export const Overline = ({ children }) => (
  <div className="overline text-[#52525b] mb-3">{children}</div>
);

export const Card = ({ children, className = "" }) => (
  <div className={`border border-black p-5 ${className}`}>{children}</div>
);
